export const labelFor = (map, v, fallback) =>
  v == null ? '—' : (map[v] ?? fallback ?? v);
